import { useGtag } from "./useGtag.js";
export function useTrackEvent(...args) {
  const { gtag } = useGtag();
  gtag("event", ...args);
}
